// @flow

import { STATUS_DEFAULT, STATUS_LOADING, STATUS_FAILURE, STATUS_SUCCESS } from 'constants/statusConstants';
import { FETCH_CLUBS_START, FETCH_CLUBS_SUCCESS, FETCH_CLUBS_FAILURE } from 'actions/clubsActions';

import type { ClubPreviewType } from 'types/Club';
import type { Status } from 'types/Status';
import type { ActionType } from 'types/Actions';

export type State = {
  clubs: Array<ClubPreviewType>,
  status: Status
};

const initialState: State = {
  clubs: [],
  status: STATUS_DEFAULT
};

export default function(state: State = initialState, action: ActionType): State {
  switch (action.type) {
    case FETCH_CLUBS_START:
      return {
        ...state,
        status: STATUS_LOADING
      };
    case FETCH_CLUBS_SUCCESS:
      return {
        ...state,
        clubs: action.payload.clubs,
        status: STATUS_SUCCESS
      };
    case FETCH_CLUBS_FAILURE:
      return {
        ...state,
        status: STATUS_FAILURE
      };
    default:
      return state;
  }
}
